const AlignRight = () => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="96" height="96" rx="48" />
      <g clipPath="url(#clip0_127_3284)">
        <path
          d="M48.028 23.9853C39.1818 23.9853 30.3338 23.9853 21.4838 23.9853C21.0416 24.0033 20.5989 23.9635 20.1671 23.8668C18.7111 23.4755 17.8514 22.1211 18.0264 20.5768C18.1183 19.8851 18.452 19.2482 18.9684 18.7789C19.4849 18.3097 20.1507 18.0383 20.848 18.0128C21.0813 18.0015 21.3164 18.0034 21.5515 18.0034C39.2 18.0034 56.8491 18.0034 74.4988 18.0034C75.0364 17.984 75.5738 18.0474 76.092 18.1915C77.4634 18.6374 78.2327 20.0068 78.0277 21.4797C77.9215 22.1458 77.5913 22.7558 77.0917 23.209C76.592 23.6621 75.9527 23.9313 75.2794 23.9721C74.9766 23.991 74.6699 23.9853 74.3652 23.9853L48.028 23.9853Z"
          fill="black"
        />
        <path
          d="M48.1055 54.0612C56.9993 54.0612 65.8938 54.0612 74.7888 54.0612C76.858 54.0612 78.1861 55.4024 78.0469 57.3362C77.9885 58.02 77.6936 58.6621 77.213 59.152C76.7323 59.642 76.096 59.949 75.4134 60.0205C75.1086 60.0487 74.8039 60.0449 74.4973 60.0449C56.8488 60.0449 39.1997 60.0449 21.55 60.0449C21.0822 60.0656 20.6136 60.0251 20.1561 59.9245C18.7021 59.5314 17.8462 58.1751 18.023 56.6307C18.1083 55.9375 18.4404 55.2981 18.9586 54.8297C19.4767 54.3612 20.1463 54.0951 20.8446 54.08C23.3803 54.0442 25.9142 54.0631 28.4499 54.0631L48.1055 54.0612Z"
          fill="black"
        />
        <path
          d="M57.0456 42.0157C51.2016 42.0157 45.3577 42.0157 39.5138 42.0157C39.0716 42.0342 38.629 41.995 38.197 41.8991C36.7335 41.506 35.8738 40.1535 36.045 38.6091C36.1361 37.9165 36.4694 37.2785 36.9858 36.8082C37.5023 36.3378 38.1686 36.0655 38.8667 36.0395C39.0548 36.0395 39.2429 36.0395 39.431 36.0395C51.1653 36.0395 62.8995 36.0395 74.6338 36.0395C75.0547 36.0226 75.4759 36.0612 75.8866 36.1542C77.3652 36.553 78.2399 37.9563 78.0254 39.512C77.9205 40.2162 77.563 40.8582 77.0196 41.3182C76.4762 41.7782 75.784 42.0248 75.0721 42.012C70.2377 42.0327 65.4033 42.0214 60.5689 42.0214L57.0456 42.0157Z"
          fill="black"
        />
        <path
          d="M57.0354 78.0737C51.1927 78.0737 45.3494 78.0737 39.5054 78.0737C39.0632 78.0915 38.6206 78.0517 38.1886 77.9552C36.7327 77.562 35.8749 76.2095 36.0498 74.6651C36.1421 73.9736 36.4759 73.3369 36.9923 72.8677C37.5087 72.3985 38.1743 72.127 38.8715 72.1012C39.0822 72.0899 39.2929 72.0918 39.5035 72.0918C51.1914 72.0918 62.8787 72.0918 74.5653 72.0918C75.0073 72.0735 75.4499 72.1121 75.8821 72.2066C77.3361 72.5997 78.1977 73.9579 78.0227 75.4985C77.9387 76.1928 77.6071 76.8335 77.0888 77.3031C76.5706 77.7726 75.9003 78.0396 75.2011 78.0549C72.1913 78.0906 69.1929 78.0718 66.1888 78.0718L57.0354 78.0737Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_127_3284">
          <rect
            width="60.0596"
            height="60.0822"
            fill="white"
            transform="translate(18 18)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AlignRight;
